import { getLogin, isImpersonationSession } from "../../../ressources/functions/helper";
import { config as getConfig } from '../../../ressources/functions/Config';
import { encrypt_storage_values, decrypt_storage_values } from "../../../ressources/functions/helper";

// Global variable to store sbdrive session details
export var sbdrive = undefined;

export async function getSBdriveToken() {
    const login = getLogin();
    let config = getConfig;

    const storage = isImpersonationSession() ? sessionStorage : localStorage;
    const localSBdrive = storage.getItem("D");
    if (localSBdrive) {
        try {
            const decryptedData = decrypt_storage_values(localSBdrive);
            sbdrive = JSON.parse(decryptedData);
            if (sbdrive?.is_active) {
                // console.log("Using existing sbdrive from localStorage:", sbdrive);
                return sbdrive;
            }
        } catch (e) {
            console.warn("Failed to parse sbdrive in localStorage:", e);
        }
    }

    if (login && !sbdrive && config?.sbdrive) {
        try {
            const response = await fetch("../api/v1/repo/s/sbdrive/login", {
                method: "POST",
                body: JSON.stringify({
                    "name": login.username,
                    "value": "",
                    "source": "media"
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Semabench-Token': login.ticket,
                    'source': 'media'
                }
            });
            
            const data = await response.json();
            // console.log(data)
            sbdrive = {...data};
            storage.setItem("D", encrypt_storage_values(JSON.stringify(sbdrive)));
            return data;
        } catch (error) {
            console.error("SBDrive login error:", error);
            return null;
        }
    }
    return sbdrive;
}
